import './scss/style.scss'
import 'swiper/scss'
import 'swiper/scss/pagination'
import DisableScroll from './js/lib/disable-scroll'
import Forms from './js/lib/forms'
import UtmHandler from './js/lib/utmHandler'

// GA all pages

window.dataLayer = []
const documentTitle = document.title.slice(2, -12)

function getCookie (name) {
  var dc = document.cookie
  var prefix = name + '='
  var begin = dc.indexOf('; ' + prefix)
  if (begin === -1) {
    begin = dc.indexOf(prefix)
    if (begin !== 0) return null
  } else {
    begin += 2
    var end = document.cookie.indexOf(';', begin)
    if (end === -1) {
      end = dc.length
    }
  }
  return decodeURI(dc.substring(begin + prefix.length, end))
}

var gaCookie = getCookie('_ga')

if (gaCookie != null) {
  window.dataLayer.push({
    page_name: documentTitle
  })
}

// Throttles calls to a callback function for a specified amount of time.
window.throttle = (callback, wait = 100) => {
  let timer = null

  return function () {
    const args = arguments
    const context = this
    if (timer === null) {
      timer = setTimeout(() => {
        callback.apply(context, args)
        timer = null
      }, wait)
    }
  }
}

window.addEventListener('load', function (event) {
  // Ajax requests
  window.ajaxReq = function ajaxReq () {
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest() // eslint-disable-line
    } else if (window.ActiveXObject) {
      return new ActiveXObject('Microsoft.XMLHTTP') // eslint-disable-line
    } else {
      console.log('Browser does not support XMLHTTP.')
      return false
    }
  }

  // Load JS scripts
  window.loadJS = (() => {
    // map of script url to list of callbacks
    const callbacks = {}
    // map of script url to "is already loaded"
    const loaded = {}

    return (file, callback) => {
      // if this is NOT the first time we see this script
      if (typeof callbacks[file] === 'object') {
        if (typeof loaded[file] === 'undefined') {
          // when the script is still loading, add the callback to the list of
          // callbacks for this script
          callbacks[file].push(callback)
        } else {
          // when the script is already loaded -> trigger the callback immediately
          callback()
        }
        return
      }

      callbacks[file] = [callback]
      // DOM: Create the script element
      var jsElm = document.createElement('script')
      // set the type attribute
      jsElm.type = 'application/javascript'
      // make the script element load file
      jsElm.src = file
      // add a callback
      jsElm.addEventListener('load', () => {
        loaded[file] = true
        const fileCallbacks = callbacks[file]
        for (let i = 0; i < fileCallbacks.length; i++) {
          const callback = fileCallbacks[i]
          if (typeof callback === 'function') {
            callback()
          }
        }
      })
      // finally insert the element to the body element in order to load the script
      document.body.appendChild(jsElm)
    }
  })()

  // Disable scroll
  window.disableScroll = new DisableScroll()

  // Recaptcha Script
  const RecaptchaScript = new Forms()
  RecaptchaScript.loadScript()

  // UtmHandler
  UtmHandler.setup()
})
